import React, { useState } from "react";
import {Alert} from "../../../controls";

const checkMultipleTicks = (ticks) => {
  let multipleTicks = -1;
  if (ticks && Array.isArray(ticks))
    ticks.forEach(tick => {
      if (tick)
        multipleTicks++;
    })
   return multipleTicks < 0 ? false : multipleTicks;
}


const CompaniesValidator = (props) => {
  const record = props.data ?  props.data.record : props.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  });

  let error = false;
  let errorMessage = "";

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) {
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }

  if (!error && !record.companyName) {
    error = true;
    errorMessage = "'Company Name' is required";
  }
  // if (!error && !record.companyCode) {
  //   error = true;
  //   errorMessage = "'Company Code' is required";
  // }
  // if (!error && !record.branchCode) {
  //   error = true;
  //   errorMessage = "'Branch Code' is required";
  // }

  if (!error &&
      !record.isClient && !record.isSupplier && !record.isFuelSupplier && !record.isPermitSupplier && !record.isAirline && !record.isShipper && !record.isConsignee && !record.isGsa && !record.isGha && !record.isCgha) {
    error = true;
    errorMessage = "Tick one of the company relation indicators";
  }
  const ticks = [record.isClient, record.isSupplier, record.isPermitSupplier, record.isAirline, record.isShipper, record.isConsignee, record.isGsa, record.isGha, record.isCgha];
  // if (!error && checkMultipleTicks(ticks)) {
  //   error = true;
  //   errorMessage = "Tick only ONE of the company relation indicators";
  // }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  // return (
  //   <div style={{display:"none"}}>
  //     {state.errorMessage}
  //   </div>
  // );
  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default CompaniesValidator;
